import { cn } from '@/shared/cn';

export type LegendProps = {
  className?: string;
};

/** Design / budget-target / actual triad — text colour only, per deck table legend. */
export function Legend({ className }: LegendProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-medium',
        className,
      )}
      aria-label="Design, budget target, and actual legend"
    >
      <span className="text-[var(--ink-tertiary)]">Design</span>
      <span className="text-[var(--state-warning)]">Budget target</span>
      <span className="text-[var(--ink-primary)]">Actual</span>
    </div>
  );
}
